export const no = {
  returnLineItems: {
    refund: "Refusjon(er)",
    exchange: "Bytte(r)",
    discount: "Rabatt(er)",
  },
  returnStoreAddress: {
    mapButton: "Vis på kart",
  },
  downloadLabel: {
    label: "Last ned etiketten min",
    bonDeRetour: "Last ned returseddelen min",
  },
  returnRequestDate: {
    label: "Returforespørselen din ble opprettet {{date}} kl. {{time}}",
  },
  actions: {
    continue: "Fortsett",
  },
  "order-identification": {
    title: "Spor bestillingen din",
    description: "Skriv inn bestillingsdetaljene for å spore pakken din",
    fields: {
      "zip-code": {
        title: "Postnummer",
        description: "Skriv inn leveringspostnummeret ditt",
        required: "Postnummer er påkrevd",
      },
      "tracking-number": {
        title: "Ordrenummer",
        description: "Skriv inn ordrenummeret ditt",
        required: "Ordrenummer er påkrevd",
      },
    },
    errors: {
      "unknown-order": {
        title: "Ukjent ordrenummer",
        description: "Ordrenummeret ble ikke funnet, vennligst sjekk det",
      },
      "search-error": {
        title: "Søkefeil",
        description:
          "Vi kunne ikke finne bestillingen. Vennligst prøv igjen senere.",
      },
    },
  },
  delivery: "Levering",
  "parcel-history": "Pakkehistorikk",
  "order-details": {
    title: "Ordredetaljer",
    "tracking-number": "Sporingsnummer",
    "order-number": "Ordrenummer",
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Forventet leveringsdato",
      deliveredOn: "Levert den",
      from: "fra",
      to: "til",
    },
  },
  deliveryAddress: {
    title: "Leveringsadresse:",
    titlePickup: "Adresse til hentested:",
    orderDetails: {
      title: "Ordredetaljer:",
      trackingNumber: "Sporingsnummer:",
      orderNumber: "Ordrenummer:",
      orderDate: "Ordredato:",
    },
  },
  pickupPoint: {
    title: "Hentested",
    openingHours: "Åpningstider:",
    closed: "Stengt",
    directions: "Veibeskrivelse",
    days: {
      monday: "Mandag:",
      tuesday: "Tirsdag:",
      wednesday: "Onsdag:",
      thursday: "Torsdag:",
      friday: "Fredag:",
      saturday: "Lørdag:",
      sunday: "Søndag:",
    },
  },
  wallet: {
    warningNotEnabled: "Du må aktivere Wallet i butikkinnstillingene dine",
  },
  crossSell: {
    youMightAlsoLike: "Du vil kanskje også like",
  },
  "rate-order": {
    "order-recap": {
      title: "Din bestilling",
      "tracking-label": "Sporingsnummer:",
      "order-label": "Ordrenummer:",
    },
    form: {
      title: "Vurder leveringen din",
      "rating-label": "Vurder leveringsopplevelsen din",
      "comment-label": "Kommentar (valgfritt)",
      "comment-placeholder": "Del opplevelsen din med oss…",
      "submit-cta": "Send inn vurderingen min",
      "update-cta": "Oppdater vurderingen min",
      "rating-required": "Vennligst velg en vurdering.",
    },
    "thank-you": {
      title: "Takk for tilbakemeldingen!",
      description:
        "Vurderingen din er lagret. Den vil hjelpe oss med å forbedre leveringsopplevelsen.",
    },
    errors: {
      "invalid-token": {
        title: "Ugyldig eller utløpt lenke",
        description:
          "Denne lenken er ikke lenger gyldig. Åpne den på nytt fra din siste sporings-e-post.",
      },
      submit: {
        title: "Noe gikk galt",
        description:
          "Vi kunne ikke lagre vurderingen din. Vennligst prøv igjen senere.",
      },
    },
  },
} as const;
